module.exports = __webpack_public_path__ + "static/media/timer-dark.7237d0fe.svg";